import { FunctionComponent } from "react";

/**
 * Workaround for Betabit components when icon is not required for buttons, menu items etc.
 * @returns Nothing
 */
const NoIcon: FunctionComponent = () => null;

export default NoIcon;
